import { getUrlParamsToObject, isHRCPage, getDefaultSrc, getEnv, now } from 'helpers';
import { checkLastSrc, getHeapCookieData } from 'cookies';
import { track, trackUserAgent, initHeapTracking, trackDarkMode, initHeapStub } from '../trackers';
window.heapLoadstartTime = now();
function executeInit() {
    resetCampaignProperties(); // To make sure this is the first thing that gets through heap queue
    let supportedParams = ['formpath', 'projectid'];
    const getParams = getUrlParamsToObject('', true);
    const isHRC = isHRCPage();
    const eventProperties = {};
    const supportedTrackingParams = ['src', 'sub_id', 'sub2_id', 'pub_id', 'account', 'campaign', 'ad_group', 'keyword', 'campaignid', 'adgroupid', 'agid', 'keywordid', 'loc1', 'loc2', 'kw', 'gclid', 'utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'program', 'motivation', 'quadlink', 'ccid', 'clk', 'qtr', 'fb_campaign_id', 'yh_campaign_id', 'yh_line_id', 'yh_cr_id', 'yh_ad_id', 'yh_domain', 'yh_subdomain', 'vmcid', 'tk_campaign_id', 'tk_adgroup_id', 'tk_ad_id', 'tk_placement', 'lander'];
    const applyUpperCase = ['ccid', 'clk', 'qtr'];
    const trackingParamsNeedingRedshiftPrefix = ['lander'];
    const redshiftPrefix = 'redshift_';
    const hasAVMParam = getParams.channel && getParams.channel.toLowerCase() === 'avm';
    // Needed for redshift load
    const trackingParamsTranslations = {
        projectid: 'project_id',
        formpath: 'form_path'
    };
    // If not on HRC, then support marketing params as well
    if (!isHRC) {
        supportedParams = supportedParams.concat(supportedTrackingParams);
    }
    // Check if there's a param to identify homeowner
    if (getParams.userid) {
        track('identify', getParams.userid);
    }
    // Check if there's a param to identify contractor
    if (getParams.contractorid) {
        track('identify', getParams.contractorid);
    }
    // map avm parameters to UTM
    if (hasAVMParam) {
        const { partnersourceid, channel, creative, placement, os, device, lander } = getParams;
        const data = {};
        if (partnersourceid) {
            data.utm_source = partnersourceid.split(' ')[0];
            data.utm_campaign = partnersourceid;
        }
        if (channel) {
            data.utm_medium = channel;
        }
        if (creative) {
            data.utm_content = creative;
        }
        if (placement) {
            data.utm_term = placement;
        }
        if (lander) {
            data.lander = lander;
        }
        if (device) {
            data.device = device;
        }
        if (os) {
            data.os = os;
        }
        Object.assign(getParams, data);
        if (Object.keys(data).length) {
            document.addEventListener('modgtm.loaded', () => {
                if (window.dataLayer) {
                    Object.entries(data).forEach(([key, value]) => {
                        window.dataLayer.push({ [key]: value });
                    });
                }
            }, { once: true });
        }
    }
    // Collect supported event properties from URL
    for (let name in getParams) {
        if (getParams.hasOwnProperty(name)) {
            let eventName = typeof trackingParamsTranslations[name] !== 'undefined' ? trackingParamsTranslations[name] : name;
            if (~supportedParams.indexOf(name)) {
                if (applyUpperCase.includes(eventName)) {
                    eventName = eventName.toUpperCase();
                }
                if (trackingParamsNeedingRedshiftPrefix.includes(name)) {
                    eventName = `${redshiftPrefix}${eventName}`;
                }
                eventProperties[eventName] = getParams[name];
            }
        }
    }
    // Set timestamp whenever we find src parameter on url
    if (eventProperties.hasOwnProperty('src') || eventProperties.hasOwnProperty('utm_source')) {
        eventProperties.timestamp = Date.now();
    }
    else if (window.isWordpress) { // I'm sorry
        // Set default src if no tracking params are available (in url or in cookie)
        if (Object.keys(eventProperties).length === 0) {
            const heapCookieData = getHeapCookieData();
            // if no heap cookie, add a src
            if (!heapCookieData) {
                eventProperties.src = getDefaultSrc();
            }
            else if (!heapCookieData.src && !heapCookieData.utm_source) {
                eventProperties.src = getDefaultSrc();
            }
            // 24 hour last touched default check
            else if ((heapCookieData.src || heapCookieData.utm_source) && checkLastSrc()) {
                if (heapCookieData.src) {
                    eventProperties.src = getDefaultSrc();
                }
                else if (heapCookieData.utm_source) {
                    eventProperties.utm_source = '';
                }
            }
        }
    }
    else {
        if (checkLastSrc() && !isHRC) {
            // if not a source in url params, check cookie, and if older than one day, set to mod001
            // but do NOT do this on the HRC
            const heapCookie = getHeapCookieData();
            if (heapCookie.src) {
                eventProperties.src = 'Mod001';
            }
            else if (heapCookie.utm_source) {
                eventProperties.utm_source = '';
            }
        }
    }
    if (window.additionalEventProperties) {
        if (window.additionalEventProperties.heapStubLoaded) {
            eventProperties.heapStubLoaded = window.additionalEventProperties.heapStubLoaded;
        }
        if (window.additionalEventProperties.userSessionStartedAt) {
            eventProperties.userSessionStartedAt = window.additionalEventProperties.userSessionStartedAt;
        }
    }
    // Check if Heap event props are available from query string
    if (Object.keys(eventProperties).length) {
        if (typeof window.heap !== 'undefined') {
            // Clear previous Heap event props if there's 'src' or 'utm_source' param and it's not the HRC
            if (!isHRC && (eventProperties.hasOwnProperty('src') || eventProperties.hasOwnProperty('utm_source'))) {
                window.Modalytics.heap('clearEventProperties', eventProperties);
            }
            if ('production' !== getEnv() && eventProperties.quadlink) {
                eventProperties.quadlink = encodeURIComponent(eventProperties.quadlink);
            }
            window.Modalytics.heap('addEventProperties', eventProperties);
        }
    }
    // Custom page view event
    window.Modalytics.heap('track', ['Page Visited', eventProperties]);
    trackDarkMode();
    trackUserAgent();
}
function resetCampaignProperties() {
    var _a;
    if (!window.location.hostname.includes('affordablestairliftsolutions.com') && !window.location.hostname.includes('airconditioningpros.org')) {
        return;
    }
    const heap = (_a = window.Modalytics) === null || _a === void 0 ? void 0 : _a.heap;
    if (typeof heap !== 'function') {
        return;
    }
    heap('removeEventProperty', 'Test ID');
    heap('removeEventProperty', 'Variation Name');
    heap('addUserProperties', {
        'Test ID': '',
        'Variation Name': ''
    });
}
/**
 * Init
 */
function init() {
    if ('isHeapLoaded' in window || 'isHeapStubLoaded' in window) {
        executeInit();
    }
    else {
        document.addEventListener('heap.loaded', function () {
            executeInit();
        }, { once: true });
    }
}
function initHeap() {
    initHeapTracking();
}
window.addEventListener('load', function () {
    // If heap is already loaded in head tag
    if ('heap' in window) {
        return false;
    }
    // Initialize Heap stub to queue calls before SDK loads
    initHeapStub();
    // Queue all the event properties in a stub before SDK loads
    init();
    if (window.disableHeapIdlize) {
        initHeap();
    }
    else {
        if ('IdlizeQueue' in window) {
            window.IdlizeQueue.pushTask(() => {
                initHeap();
            });
        }
    }
});
export { init };
